jQuery(document).ready(function($) {

    function getNonOrderableColumns(tableSelector) {
        let nonOrderable = [];
        $(`${tableSelector} thead th`).each(function(index) {
            if ($(this).attr("data-orderable") === "false") {
                nonOrderable.push(index);
            }
        });
        return nonOrderable;
    }

    $('#project-table').DataTable({
        destroy: true,
        responsive: true,
        scrollX: true,
        autoWidth: false,
        lengthMenu: [
            [10, 50, 100, 500, -1],
            [10, 50, 100, 500, 'All']
        ],
        pageLength: 100,
        language: {
            "decimal": ",",
            "thousands": ".",
            "sProcessing": "Traitement en cours...",
            "sSearch": "Rechercher :",
            "sLengthMenu": "_MENU_",
            "sInfo": "Affichage de _START_ à _END_ sur _TOTAL_ éléments",
            "sInfoEmpty": "Affichage de 0 à 0 sur 0 éléments",
            "sInfoFiltered": "(filtré à partir de _MAX_ éléments au total)",
            "sInfoPostFix": "",
            "sLoadingRecords": "Chargement en cours...",
            "sZeroRecords": "Aucun élément à afficher",
            "sEmptyTable": "Aucune donnée disponible dans le tableau",
            "oAria": {
                "sSortAscending": ": activer pour trier la colonne par ordre croissant",
                "sSortDescending": ": activer pour trier la colonne par ordre décroissant"
            }
        },
        columnDefs: [
            { orderable: false, targets: getNonOrderableColumns("#project-table") }
        ],
        fnInitComplete: function () {
            $("tfoot").next().hide();
        },
        fnDrawCallback: function (oSettings) {
            $("tfoot").next().hide();
        }

    });

    const filetable = $('#files-table').DataTable({
        destroy: true,
        responsive: true,
        ordering: true,
        scrollX: true,
        autoWidth: false,
        language: {
            "decimal": ",",
            "thousands": ".",
            "sProcessing": "Traitement en cours...",
            "sSearch": "Rechercher :",
            "sLengthMenu": "_MENU_",
            "sInfo": "Affichage de _START_ à _END_ sur _TOTAL_ éléments",
            "sInfoEmpty": "Affichage de 0 à 0 sur 0 éléments",
            "sInfoFiltered": "(filtré à partir de _MAX_ éléments au total)",
            "sZeroRecords": "Aucun élément à afficher",
            "sEmptyTable": "Aucune donnée disponible dans le tableau",
            "oAria": {
                "sSortAscending": ": activer pour trier la colonne par ordre croissant",
                "sSortDescending": ": activer pour trier la colonne par ordre décroissant"
            }
        }
    });

    const searchInput = document.querySelector('input[type="search"][aria-controls="files-table"]');
    const fileTypeFilter = $('#fileTypeFilter');

    // Filtre Type
    fileTypeFilter.on('change', function () {
        const val = this.value ? this.value.trim() : '';
        const currentSearch = searchInput.value.trim().split(' ');

        // Enlève les anciens types
        const cleanedSearch = currentSearch.filter(word => !["coffrage", "ferraillage", "divers", "undefine"].includes(word));

        // Ajoute le type sélectionné
        if (val) {
            cleanedSearch.push(val);
        }

        // Mets à jour la recherche
        const newSearch = cleanedSearch.join(' ').trim();
        searchInput.value = newSearch;
        $(searchInput).trigger('input');
    });

    // Recherche Standard
    $(searchInput).on('input', function () {
        filetable.search(this.value).draw();
    });




});
